import React, { useState , useEffect} from "react";
import axios from "axios";
import "./App.css";
import WeatherForcastDay from "./WeatherForcastDay";

export default function Weatherforcast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forcast, setForcast] = useState(null);

  function handleResponse(response) {
    setForcast(response.data.daily);
    setLoaded(true);
  }

   useEffect(() => {
     setLoaded(false);
   }, [props.coordinate]);

  // if (pageState == 1 ) {
  //   setLoaded(2);
  //   //api call
  // }
  // esle if (pageState ==2){
  //   //do nothing
  // }
  // else if (pageState == 3){
  //   setPageState(4)
  //   //render page
  // }
  if (loaded) {
    return (
      <div className="forcast">
        <div className=" row forecast-row">
          {forcast.map(function (dailyForecast, index) {
            console.log(dailyForecast);
            if (index < 5) {
              return (
                <div className="col forecast-col" key={index}>
                  <WeatherForcastDay data={dailyForecast} />
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  } else {
    const apiKey = "b95f179627c8dd37f41e1be6e3250e19";
    let lat = props.coordinate.lat;
    let lon = props.coordinate.lon;

    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then((response) => {
      // Adding a 200-millisecond delay
      setTimeout(() => {
        handleResponse(response);
      }, 200);
    });
    return null;
  }
}
